import React, { Component, Fragment } from 'react';

import classNames from 'classnames';
import { Button } from 'components/ClubComponents';
import { I18n, translate } from 'components/translate';
import { UserPhoto } from 'components/user';
import CommentHeaderStatus from 'modules/community/commentList/CommentHeaderStatus';
import CommentPersonaHeader from 'modules/community/commentList/CommentPersonaHeader';
import CommentsActionsDropdown from 'modules/community/commentList/CommentsActionsDropdown';
import CommentDetailContent from 'modules/community/history/CommentDetailContent';
import PropTypes from 'prop-types';

import './CommentChat.scss';

const commentUserClass = 'comment-list__comment-user';

@translate()
export default class CommentChat extends Component {
  static propTypes = {
    t: PropTypes.func,
    item: PropTypes.shape({
      commentClass: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string
      }),
      commentDate: PropTypes.string,
      content: PropTypes.string,
      id: PropTypes.string,
      lastAction: PropTypes.string,
      page: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        module: PropTypes.string
      }),
      status: PropTypes.string,
      type: PropTypes.string,
      user: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        email: PropTypes.string,
        pictureFileKey: PropTypes.string
      })
    }),
    isTopic: PropTypes.bool,
    commentStatusUpdate: PropTypes.func,
    userNameEmail: PropTypes.string,
    showMoreComments: PropTypes.object,
    onAnswerText: PropTypes.func,
    answerListText: PropTypes.object,
    toogleAnswer: PropTypes.func,
    commentAnswerReply: PropTypes.func,
    answerBoxOpened: PropTypes.object,
    showMore: PropTypes.func,
    showUserPhoto: PropTypes.bool,
    showStatus: PropTypes.bool,
    highlighted: PropTypes.bool
  };

  static defaultProps = {
    userNameEmail: '',
    answerBoxOpened: {},
    showUserPhoto: false,
    highlighted: false,
    item: {}
  };

  constructor(props) {
    super(props);

    this.renderAnswer = this.renderAnswer.bind(this);
    this.renderAnswerBox = this.renderAnswerBox.bind(this);
    this.commentAnswerReply = this.commentAnswerReply.bind(this);
  }

  async commentAnswerReply(item) {
    const { commentAnswerReply, answerListText, toogleAnswer } = this.props;

    await commentAnswerReply(item, answerListText[item.id]);
    toogleAnswer(item.id);
  }

  handleToggleAnswer = () => {
    const { item, toogleAnswer } = this.props;

    toogleAnswer && toogleAnswer(item.id);
  };

  handleAnswer = (e) => {
    const { item, onAnswerText } = this.props;

    e && e.persist();
    onAnswerText && onAnswerText(e, item.id);
  };

  handleAnswerAndAprove = () => {
    const { item } = this.props;

    this.commentAnswerReply(item);
  };

  renderPhoto = () => {
    const { item, showUserPhoto } = this.props;

    if (!showUserPhoto || !item.user) {
      return null;
    }

    const { name, pictureFileKey } = item.user || {};

    return (
      <UserPhoto
        className="_d-inline-flex _justify-content-center _align-items-center _mr-3 _rounded-full _text-white _text-3 _tw-w-10 _tw-h-10"
        name={name}
        pictureFileKey={pictureFileKey}
        data-test="comment-chat-user"
      />
    );
  };

  renderAnswerBox(item) {
    const { answerListText, t } = this.props;

    return (
      <Fragment>
        <textarea
          className="comment-list__comment-cell__container__comment__answer-box"
          name={`answer-box-${item.id}`}
          onChange={this.handleAnswer}
          value={answerListText[item.id]}
          placeholder={t('community.write_your_answer_input')}
        />
        <div className="comment-list__comment-cell__container__comment__buttons">
          <Button.Secondary
            size={Button.SIZE.SMALL}
            disabled={!answerListText[item.id]?.trim()}
            onClick={this.handleAnswerAndAprove}
          >
            <I18n label="general.answer_and_approve" />
          </Button.Secondary>

          <Button.Primary
            outline
            size={Button.SIZE.SMALL}
            onClick={this.handleToggleAnswer}
            className="_tw-text-sm"
          >
            <I18n label="general.cancel" />
          </Button.Primary>
        </div>
      </Fragment>
    );
  }

  renderOpenAnswer = (answerLabel) => (
    <div className="_tw-text-sm">{answerLabel}</div>
  );

  renderCloseAnswer = (answerLabel) => (
    <Button.Primary
      className="_h-auto _p-0 _tw-text-sm"
      outline
      onClick={this.handleToggleAnswer}
      data-test="btn-comment-toggle"
    >
      {answerLabel}
    </Button.Primary>
  );

  renderAnswer(item) {
    const { answerBoxOpened, toogleAnswer } = this.props;

    const answerLabel = <I18n label="general.answer" />;
    const isOpen = answerBoxOpened[item.id];

    return (
      <Fragment>
        {toogleAnswer && (
          <div
            className={classNames(
              'comment-answer _mt-3 _tw-h-6 _d-flex _align-items-center',
              {
                'is-open': isOpen,
                'is-closed': !isOpen
              }
            )}
            data-test="comment-answer"
          >
            {isOpen
              ? this.renderOpenAnswer(answerLabel)
              : this.renderCloseAnswer(answerLabel)}
          </div>
        )}
        {isOpen && this.renderAnswerBox(item)}
      </Fragment>
    );
  }

  render() {
    const {
      item,
      commentStatusUpdate,
      userNameEmail,
      showMoreComments,
      showMore,
      isTopic,
      showStatus,
      highlighted
    } = this.props;

    return (
      <div
        className={classNames(
          'comment-chat _position-relative _d-flex _d-flex-row _d-flex-1 _mb-3 _mb-lg-5',
          {
            '_bg-brand-primary-lightest _rounded-sm is-highlighted': highlighted
          }
        )}
        data-test="comment-chat"
      >
        {this.renderPhoto()}
        <div
          className={classNames('_d-flex _flex-column', {
            '_w-full': isTopic,
            'comment-content': !isTopic
          })}
        >
          <div className="_d-block _tw-space-x-4">
            <CommentHeaderStatus
              item={item}
              showTopic={isTopic}
              showUsernameEmail={userNameEmail}
              pendingHighlight
              showStatus={showStatus}
              className="comment-header"
            />
            <CommentsActionsDropdown
              item={item}
              commentStatusUpdate={commentStatusUpdate}
              commentUserClass={commentUserClass}
              className="_position-absolute _tw-right-0 _tw-top-0 comment-actions"
            />
          </div>
          <CommentPersonaHeader item={item} />

          <CommentDetailContent
            item={item}
            showMore={showMore}
            showMoreComments={showMoreComments}
          />

          {this.renderAnswer(item)}
        </div>
      </div>
    );
  }
}
